this.NaoSim = [
	{value: false, text: 'Não'},
	{value: true, text: 'Sim'}
];

this.AnosLectivos = [
	{ value: 1, text: '2018 / 2019' },
	{ value: 2, text: '2019 / 2020' },
	{ value: 3, text: '2020 / 2021' },
	{ value: 4, text: '2021 / 2022' },
	{ value: 5, text: '2022 / 2023' }
];
this.AnoLectivoActual = 5;

this.AnosCurriculares = [
	{ value: 1, text: '1.º ano' },
	{ value: 2, text: '2.º ano' },
	{ value: 3, text: '3.º ano' },
	{ value: 4, text: '4.º ano' },
];

this.Sexos = [
	{ value: 'M', text: 'Masculino' },
	{ value: 'F', text: 'Feminino' }
];

this.TiposNota = [
	{ value: 'IN', text: 'Insuficiente', type: 'QUAL' },
	{ value: 'SU', text: 'Suficiente', type: 'QUAL' },
	{ value: 'BO', text: 'Bom', type: 'QUAL' },
	{ value: 'MB', text: 'Muito Bom', type: 'QUAL' },
	{ divider: true },
	{ value: 'NI', text: 'Não Inscrito', type: 'EXT' },
	{ value: 'NA', text: 'Não Aplicável', type: 'EXT' },
	{ value: 'MT', text: 'Mudou de Turma', type: 'EXT' },
	{ value: 'MS', text: 'Mudou Situação', type: 'EXT' },
	{ value: 'FE', text: 'Falta de Elementos de Avaliação', type: 'EXT' }
]

this.ResultadosFinais = [
	{value: false, text: 'Não transitou'},
	{value: true, text: 'Transitou'}
];

this.TiposMedidasApoio = [
	{ value: 'U', text: 'Universal' },
	{ value: 'S', text: 'Seletiva' },
	{ value: 'A', text: 'Adicional' }
]